import { Injectable } from '@angular/core';
import { FilterStateService } from '../../filter-state/filter-state.service';

@Injectable({
  providedIn: 'root'
})
export class FiltersStoreService extends FilterStateService<any> {

}
